<template>
  <pt-refund-integral-audit class="pt-refund-integral-audit__page"></pt-refund-integral-audit>
</template>

<script>
import PtRefundIntegralAudit from 'cps/integral-mall-manage/pt-refund-integral-audit/withData'
export default {
  name: 'pt-refund-integral-audit__view',
  components: {
    'pt-refund-integral-audit': PtRefundIntegralAudit
  }
}
</script>
